// extracted by mini-css-extract-plugin
export default {"root":"C0xWZRXiG6uUgu6DUxIX","divider":"WUvnzOjpljkdqYaHnleR","rangePicker":"Zs3Xjc0R5fsc6ByYcd7b","statusSelect":"dm09pIskPKFnYcyGrzvg","dFlex":"QKbN6SfD9t6bbF8lob3t"};